import { cn } from 'common/utils'

const BtnClasses = 'rounded focus:outline-none focus:shadow-outline motion-safe:transition duration-300 ease-in-out'

const VariantClasses = {
  primary: 'text-gray-200 bg-blue-600 hover:bg-blue-500',
  primary_disabled: 'text-gray-100 bg-blue-300 hover:bg-blue-200',
  secondary: 'text-gray-600 bg-gray-200 hover:bg-gray-300',
  secondary_disabled: 'text-gray-500 bg-gray-100 hover:bg-gray-50 hover:text-gray-400',
  hover: 'text-gray-500 opacity-50 hover:bg-gray-300 hover:text-gray-600',
  success: 'text-white bg-green-500 hover:bg-green-600',
  outline: 'border text-gray-600 border-gray-300 hover:border-gray-400 hover:text-gray-700',
}
const SizeClasses = {
  sm: 'text-sm px-2 py-1',
  md: 'text-base px-4 py-2',
  lg: 'text-xl px-5 py-2.5',
}

// TODO: size, outline, ...? disabled/active?
// TODO: classes https://davidhallin.com/blog/easy-tailwind-buttons/

// https://web2tailwind.com/component/button
// https://tailwindcomponents.com/component/tailwind-css-buttons

const Button = ({ variant = 'secondary', as = 'button', size = 'md', className, children, ...props }) => {
  const Tag = as

  // Apply disabled styling, if appropriate and any defined, else default for variant
  // Also, sets default button styling to secondary
  const classKey = props.disabled ? `${variant}_disabled` : variant
  const variantClasses = VariantClasses[classKey] || VariantClasses[variant] || VariantClasses.secondary

  return (
    <Tag role="button" className={cn(className, BtnClasses, variantClasses, SizeClasses[size])} {...props}>
      {children}
    </Tag>
  )
}

export default Button
